"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debounce_1 = __importDefault(require("lodash/debounce"));
const turf_1 = require("@turf/turf");
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const ManageOverlappingLines_1 = require("chaire-lib-common/lib/services/geodata/ManageOverlappingLines");
const RelocateNodes_1 = require("chaire-lib-common/lib/services/geodata/RelocateNodes");
// TODO: Make zoomLimit modifiable by user
const zoomLimit = 14; //Zoom levels smaller than this will not apply line separation
let applyAestheticChangesNonce = new Object();
// Store a reference to the last map used, for the debounced function to access current state
let lastMapRef = null;
/**
 * Debounced function to update map preferences (zoom and center).
 * Uses lastMapRef to get current values at execution time, ensuring
 * rapid events coalesce into a single update with the latest values.
 */
const debouncedUpdateMapPreferences = (0, debounce_1.default)(() => {
    if (!lastMapRef)
        return;
    const centerLatLng = lastMapRef.getCenter();
    Preferences_1.default.update({
        'map.zoom': lastMapRef.getZoom(),
        'map.center': [centerLatLng.lng, centerLatLng.lat]
    }, ServiceLocator_1.default.socketEventManager);
}, 1000);
/* This file encapsulates global map events, that do not require a specific context */
const onMouseOut = (_e) => {
    ServiceLocator_1.default.eventManager.emit('map.updateMouseCoordinates', null);
};
const onZoomEnd = (_e) => {
    const map = _e.target;
    lastMapRef = map;
    debouncedUpdateMapPreferences();
    const boundsGL = map.getBounds();
    applyAestheticChanges(boundsGL, map.getZoom());
};
const onDragEnd = (e) => {
    const map = e.target;
    if (map._draggingEventsOrder && map._draggingEventsOrder.length > 0) {
        // this helps reduce false click when dragging/panning the map
        if (map._draggingEventsOrder[map._draggingEventsOrder.length - 1] === 'mouseup') {
            map._draggingEventsOrder = [];
        }
        else {
            map._draggingEventsOrder.push('dragend');
        }
    }
    lastMapRef = map;
    debouncedUpdateMapPreferences();
    const boundsGL = e.target.getBounds();
    applyAestheticChanges(boundsGL, e.target.getZoom());
};
const onDragStart = (e) => {
    const map = e.target;
    map._draggingEventsOrder = ['dragstart'];
};
const onMouseMove = (e) => {
    ServiceLocator_1.default.eventManager.emit('map.updateMouseCoordinates', e.lngLat.toArray());
};
const globalEventDescriptors = [
    { type: 'map', eventName: 'mouseout', handler: onMouseOut },
    { type: 'map', eventName: 'zoomend', handler: onZoomEnd },
    { type: 'map', eventName: 'dragend', handler: onDragEnd },
    { type: 'map', eventName: 'dragstart', handler: onDragStart },
    { type: 'map', eventName: 'mousemove', handler: onMouseMove }
];
const applyAestheticChanges = (boundsGL, zoom) => __awaiter(void 0, void 0, void 0, function* () {
    if (!Preferences_1.default.get('features.map.prettyDisplay', false)) {
        return;
    }
    const localNonce = (applyAestheticChangesNonce = new Object());
    const isCancelled = () => localNonce !== applyAestheticChangesNonce;
    if (zoom <= zoomLimit) {
        return;
    }
    if (isCancelled && isCancelled()) {
        return;
    }
    const sw = boundsGL.getSouthWest().toArray();
    const ne = boundsGL.getNorthEast().toArray();
    const bounds = [sw, ne];
    const boundsPolygon = (0, turf_1.bboxPolygon)((0, turf_1.bbox)((0, turf_1.lineString)(bounds)));
    const layer = ServiceLocator_1.default.layerManager._layersByName['transitPaths'].source.data;
    const linesInView = (0, ManageOverlappingLines_1.getLinesInView)(boundsPolygon, layer);
    yield (0, ManageOverlappingLines_1.offsetOverlappingLines)(linesInView, isCancelled).catch(() => {
        return;
    }); // isCancelled is handled after
    if (isCancelled && isCancelled()) {
        return;
    }
    const transitNodes = ServiceLocator_1.default.layerManager._layersByName['transitNodes'].source.data;
    const nodesInView = (0, RelocateNodes_1.getNodesInView)(boundsPolygon, transitNodes);
    yield (0, RelocateNodes_1.manageRelocatingNodes)(nodesInView, linesInView, isCancelled).catch(() => {
        return;
    });
    if (isCancelled && isCancelled()) {
        return;
    }
    ServiceLocator_1.default.eventManager.emitEvent('map.updateLayer', {
        layerName: 'transitPaths',
        data: layer
    });
    ServiceLocator_1.default.eventManager.emit('map.updateLayers', {
        transitNodes: transitNodes
    });
});
exports.default = globalEventDescriptors;
//# sourceMappingURL=GlobalMapEvents.js.map